import { Box, Option } from "@mui/joy";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";
import DarkSelect from "../../common/DarkSelect";
import type { LeaveType } from "../../../api/leave/Leave.typed";

export type LeaveBalanceTypeSelectorProps = {
  leaveTypes: LeaveType[];
  selectedTypeId: number;
  onTypeChange: (typeId: number) => void;
};

export default function LeaveBalanceTypeSelector({
  leaveTypes,
  selectedTypeId,
  onTypeChange,
}: LeaveBalanceTypeSelectorProps) {
  return (
    <DarkCard dense sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <DarkTypography level="body-lg" colorVariant="accent">
          Type de congé
        </DarkTypography>
        <DarkSelect
          value={selectedTypeId}
          onChange={(_, v) => onTypeChange((v as number) ?? -1)}
          sx={{ minWidth: 260 }}
        >
          <Option value={-1}>Choisir un type</Option>
          {leaveTypes.map((t) => (
            <Option key={t.ID} value={t.ID}>
              {t.Name}
            </Option>
          ))}
        </DarkSelect>
      </Box>
    </DarkCard>
  );
}
